import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

type PageHeaderContainerProps = {
  fullWidth?: boolean;
};

export const PageHeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})<PageHeaderContainerProps>(({ theme, fullWidth = true }) => ({
  marginTop: theme.spacing(1),
  marginRight: fullWidth ? '0px' : theme.spacing(3),
  marginBottom: fullWidth ? theme.spacing(3) : '0px',
  marginLeft: fullWidth ? '0px' : theme.spacing(3),
}));

export const PageHeaderRoot = styled(Grid)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(2.875),
  '& .MuiGrid-root': {
    paddingTop: 0,
  },
})) as typeof Grid;

export const PageHeaderTitle = styled(Typography)(({ theme }) => ({
  boxSizing: 'border-box',
  paddingRight: theme.spacing(3),
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.h5.fontSize,
  lineHeight: theme.typography.h5.lineHeight,
  letterSpacing: theme.typography.h5.letterSpacing,
  color: theme.palette.common.black,
  '& > span': {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },
})) as typeof Typography;

export const FieldsRow = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  padding: 0,
  gap: theme.spacing(4),
  width: '100%',
  minWidth: 0,
}));

export const HeaderActions = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const MetadataItemRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  gap: theme.spacing(0.5),
  minHeight: theme.spacing(5),
  flex: 'none',
  flexGrow: 0,
}));

export const MetadataTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography['label-small'],
  color: theme.palette.common.black,
  whiteSpace: 'nowrap',
  alignSelf: 'stretch',
})) as typeof Typography;

export const MetadataValue = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-small'],
  color: theme.palette.common.black,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  alignSelf: 'stretch',
})) as typeof Typography;
